<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App",
  };
</script>

<style lang="less">
  #app {
    // font-family:"微软雅黑" !important;
    font-family:"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif ;
    // "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif
  }

  body {
    overflow: hidden;
    min-width: 1044px;
    /* 当显示dialog的时候 body 默认多出了一个 paading-right */
    padding-right: 0px !important;

  }
  // 全局复选框修改  选中颜色
  .el-checkbox__label {
    padding-left: 10px !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #fff !important;
    // color: unset !important;
    border-color: #D8DCE6 !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: unset !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #D8DCE6 !important;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before{
    background-color: black !important;
  }
  .el-checkbox__inner::after ,{
    border-color: black !important;
  }

  // 全局树形控件样式修改
  .el-tree-node__content:hover {
    background-color: #FAFBFC !important;
  }

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: transparent !important;
    font-weight: 600;
    color: black;
  }

  .el-tree-node__content {
    height: 32px !important;
    color: #000;
    padding: 0 !important;
  }

  //虚线添加开始===========
  .el-tree>.el-tree-node:after {
    border-top: none;
  }

  .el-tree-node {
    position: relative;
    padding-left: 0;
    // &:first-child{
    //   padding-left: 0;
    // }
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree>.el-tree-node:before {
    border-left: none;
  }
  .el-tree>.el-tree-node:after {
    border-top: none;
  }

  .el-tree-node__content>.el-tree-node__expand-icon {
    padding: 0 !important;
  }

  .el-tree-node:before {
    content: "";
    left: -10px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -8px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #cbcdce;
    bottom: 0px;
    height: 100%;
    top: -22px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #cbcdce;
    height: 20px;
    top: 17px;
    width: 8px;
  }

  //虚线添加结束===========





  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  /deep/.el-radio {
    margin-right: 20px;
  }

  //全局导航样式修改
  .el-menu-item.is-active {
    background-color: #F1F3F4;
    color: #6C9CFC;
    width: 130px !important;
  }

  .el-menu {
    border: none !important;
  }

  .el-menu-item,
  .el-submenu__title {
    color: #323233;
    height: 40px !important;
    line-height: 40px !important;
    min-width: unset !important;
  }

  .el-submenu__title {
    border-bottom: 1px solid #f2f4f6 !important;
    margin-top: 4px !important;
  }

  .el-menu-item {
    padding: 0 20px !important;
  }

  //嵌入按钮
  .el-input-group__append {
    padding: 0 15px;
  }

  /*滚动条样式*/

  &::-webkit-scrollbar {
    // display: none;
    width: 0;

  }

  /*滚动条的轨道*/
  &::-webkit-scrollbar-track {
    // display: none;
    // background-color: #061f4b;
  }

  /*滚动条里面的小方块，能向上向下移动*/
  &::-webkit-scrollbar-thumb {
    // display: none;
    background-color: #f1f3f4;
    // border-radius: 5px;
    // border: 1px solid #061f4b;
    // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb:hover {
    // display: none;
    // background-color: #a8a8a8;
  }

  &::-webkit-scrollbar-thumb:active {
    // display: none;
    // background-color: #787878;
  }



//
.el-upload__input{
  display: none !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue